import { produce } from 'immer';
import {
  SEND_A_FORM_PREVIEW_FORM_VIEW,
  SEND_A_FORM_INIT,
  SEND_A_FORM_PREVIEW_LIST_VIEW,
  SEND_A_FORM_CLOSE,
  SEND_A_FORM_FIELD_CLICKED,
  SEND_A_FORM_FIELD_CLICKED_HANDLED,
  SEND_A_FORM_SET_SELECTED_FIELDS
} from './reduxActionTypes';
import { closeSendAForm, fieldClicked, hightlightSelectedFormFields, hightlightSelectedListFields } from './reduxUpdaters';
import { FormEditorAction, FormEditorState } from '../formeditor/formeditor-types';

/**
 * This is a child reducer of the form editor reducer.
 */
export function sendAFormReduxReducer(state: FormEditorState, action: FormEditorAction) {
  return produce(state, (draft) => {
    const { type, payload } = action;

    switch (type) {
      case SEND_A_FORM_CLOSE:
        return closeSendAForm(draft, payload.completely);

      case SEND_A_FORM_FIELD_CLICKED:
        return fieldClicked(draft, payload.fieldId, payload.viewType);

      case SEND_A_FORM_FIELD_CLICKED_HANDLED:
        draft.sendAForm.lastClickedField = null;
        return draft;

      case SEND_A_FORM_PREVIEW_FORM_VIEW:
        return hightlightSelectedFormFields(draft, payload.fieldIds, payload.highlightColor);

      case SEND_A_FORM_PREVIEW_LIST_VIEW:
        return hightlightSelectedListFields(draft, payload.fieldIds, payload.highlightColor);

      case SEND_A_FORM_INIT:
        draft.sendAForm = payload.sendAForm;
        return draft;

      case SEND_A_FORM_SET_SELECTED_FIELDS:
        draft.sendAForm.selectedFieldPositionIds = payload.selectedFieldIds;
        return draft;

      default:
        return draft;
    }
  });
}
